// preloader.jsx

import Style from "./preLoader.module.css"
function Preloader() {
    return <div style={{ height: "100%", width: "100%" }}>
        <div className={`${Style.container}`}>
            <div className={`${Style.loader}`}></div>
        </div>
    </div>
}

export default Preloader